import React from "react";
import useScrollReveal from "@/hooks/useScrollReveal";

import Hero from "@/components/site/Hero";
import ChooseVibe from "@/components/site/ChooseVibe";
import Process from "@/components/site/Process";
import FeelGallery from "@/components/site/FeelGallery";
import WhatWeOffer from "@/components/site/WhatWeOffer";
import TrustedPartners from "@/components/site/TrustedPartners";
import CostEstimator from "@/components/site/CostEstimator";
import Testimonials from "@/components/site/Testimonials";
import LaunchOffer from "@/components/site/LaunchOffer";
import FAQ, { HOME_FAQS } from "@/components/site/FAQ";
import PreFooterCTA from "@/components/site/PreFooterCTA";
import SEO from "@/components/site/SEO";
import { pageSeo, localBusinessJsonLd, serviceJsonLd, faqJsonLd } from "@/lib/seo-config";

export default function HomeInteriorsDubai() {
    useScrollReveal();
    return (
        <main data-testid="page-home-interiors-dubai">
            <SEO
                {...pageSeo.homeInteriors}
                jsonLd={[
                    localBusinessJsonLd,
                    serviceJsonLd({
                        type: "Home Interiors",
                        name: "Home Interiors Dubai",
                        description: pageSeo.homeInteriors.description,
                        path: pageSeo.homeInteriors.path,
                    }),
                    faqJsonLd(HOME_FAQS),
                ]}
            />
            <Hero />
            <ChooseVibe />
            <Process />
            <FeelGallery />
            <WhatWeOffer />
            <TrustedPartners />
            <CostEstimator />
            <Testimonials />
            <LaunchOffer />
            <FAQ items={HOME_FAQS} />
            <PreFooterCTA />
        </main>
    );
}
